import {
  Box,
  Stack,
  Table,
  TableBody,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import type { ControlViolations, BackupStatus } from '@repo/api-gw-sdk';
import type React from 'react';

import { BorderlessTableCell } from '@/components/table/components';
import { BackupStatuses, ControlsSeverity } from '@/data/inventory/data';

import { BackupStatusIcon } from '../backupStatus/backupStatusIcon';

export const ControlIndicator = ({
  backgroundColor,
}: {
  backgroundColor: string;
}) => {
  return (
    <Box
      component={'span'}
      className='rounded-full w-[8px] h-[8px] m-[8px] inline-block'
      sx={{
        backgroundColor,
      }}
    />
  );
};

export const controlKeysPriorities: (keyof ControlViolations)[] = [
  'high',
  'medium',
  'low',
  'muted',
];

export const ControlsColumnIndicators = ({
  controlViolations,
  backupStatus,
}: {
  controlViolations: ControlViolations | null | undefined;
  backupStatus: BackupStatus;
}) => {
  const data = BackupStatuses[backupStatus];
  if (!data) {
    return null;
  }

  if (!controlViolations) {
    return (
      <Tooltip title={data.title}>
        <BackupStatusIcon backupStatus={backupStatus} />
      </Tooltip>
    );
  }

  return (
    <Tooltip
      disableInteractive={false}
      title={
        <Stack>
          <Typography
            className='mb-[8px]'
            sx={{
              color: 'var(--mui-palette-Tooltip-text)',
            }}
          >
            {data.title}
          </Typography>
          <Table>
            <TableBody>
              {controlKeysPriorities.map((priority) => {
                const amount = controlViolations[priority];
                return (
                  !!amount && (
                    <TableRow key={priority} className='mt-[4px] py-[2px]'>
                      <BorderlessTableCell>
                        <ControlIndicator
                          backgroundColor={ControlsSeverity[priority].color}
                        />
                      </BorderlessTableCell>
                      <BorderlessTableCell>
                        <Typography
                          className='ml-[8px]'
                          sx={{
                            color: 'var(--mui-palette-Tooltip-text)',
                          }}
                        >
                          {amount}
                        </Typography>
                      </BorderlessTableCell>
                      <BorderlessTableCell>
                        <Typography
                          className='ml-[8px]'
                          sx={{
                            color: 'var(--mui-palette-Tooltip-text)',
                          }}
                        >
                          {ControlsSeverity[priority].title}
                        </Typography>
                      </BorderlessTableCell>
                    </TableRow>
                  )
                );
              })}
            </TableBody>
          </Table>
        </Stack>
      }
      className='ml-[8px]'
      slotProps={{
        tooltip: {
          sx: {
            width: '170px',
            padding: '16px',
          },
        },
      }}
    >
      <BackupStatusIcon backupStatus={backupStatus} />
    </Tooltip>
  );
};
